import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import InstaID    from '@common/influencer-search/conditions/insta_id';
import Keyword    from '@common/influencer-search/conditions/keyword';
import Label      from '@common/influencer-search/conditions/label';
import NgLabel    from '@common/influencer-search/conditions/label-ng';
import BaseInput  from '@common/influencer-search/conditions/base-input';
import BaseSelect from '@common/influencer-search/conditions/base-select';
import Line       from '@common/influencer-search/conditions/line';
import Accordion  from '@common/influencer-search/conditions/accordion';
import Slider     from '@common/influencer-search/conditions/slider';
import CheckBox   from '@common/influencer-search/conditions/checkbox';

// -------------------------------------------------------


// フォロワーレンジ
const FOLLOWERS_RANGE = { 0: 0, 1: 1000, 2: 2000, 3: 3000, 4: 4000, 5: 5000, 6: 6000, 7: 7000, 8: 8000, 9: 9000, 10: 10000,
                      11: 12500, 12: 15000, 13: 17500, 14: 20000, 15: 25000, 16: 30000, 17: 35000, 18: 40000, 19: 45000, 20: 50000,
                      21: 75000, 22: 100000, 23: 150000, 24: 200000, 25: 250000, 26: 300000, 27: 400000, 28: 500000, 29: 750000, 30: 1000000
                    }

// エンゲージ率レンジ
let engageRange   = [ '0.5', '1.0', '1.5', '2.0', '2.5', '3.0', '3.5', '4.0', '4.5', '5.0', '5.5', '6.0', '6.5', '7.0', '7.5', '8.0', '8.5', '9.0', '9.5',
                      10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100 ];

// 年代レンジ
let GENERATION_RANGE = { 1: 10, 2: 20, 3: 30, 4: 40, 5: 50 };

class InfluencerConditions extends React.Component {
  /*
   * 検索内容の設定
   */
  changeSetting(column, data, not_api) {
    let options = this.props.options;
    if( (options[column] == undefined && data == '') || (options[column] == data)) return;
    
    if( data == '' || data.length == 0 || Object.keys(data).length == 0 ){
      delete options[column];
    } else {
      options[column] = data;
    }
    if( not_api !== true ) this.props.search_ev.bind(this)(options);
  }
  // -------------------------------------------------------
  
  /*
   * 検索内容の設定
   */
  changeScore(id, value) {
    let options = this.props.options;
    options[id] = value;
    this.props.search_ev.bind(this)(options);
  }
  // -------------------------------------------------------
  
  /*
   * 検索内容の設定
   */
  resetOrderChangeScore(id, value) {
    let options = this.props.options;
    options[id] = value;
    
    delete options.order;
    this.props.search_ev.bind(this)(options);
  }
  // -------------------------------------------------------
  
  enterButton(e) {
    e.preventDefault();
    document.activeElement.blur();
  }
  // -------------------------------------------------------
  
  /*
   * 検索内容の設定
   */
  changeScoreArray(id, value) {
    let options = this.props.options;
    if( options[id] == undefined ) options[id] = [];
    
    if( options[id].indexOf(value) == -1 ){
      options[id].push(value);
    } else {
      options[id] = options[id].filter((v) => { if( v != value ) return v; });
    }
    this.props.search_ev.bind(this)(options);
  }
  // -------------------------------------------------------
  
  render() {
    let tab = this.props.tab;
    
    let monthList = [];
    for( let i = 0; i < 12; i++ ) monthList.push({ id: Moment().add((i * -1), 'month').format('YYYYMM'), name: Moment().add((i * -1), 'month').format('YYYY年M月') });
    
    // カラム設定
    let columns = [];
    if( tab == 'post_search' ){
      columns = [
        <Keyword />,
        <BaseSelect id="product_type" name="投稿種別" change_ev={this.resetOrderChangeScore.bind(this)} list={[{ id: 'REELS', name: 'リール' }, { id: 'FEED', name: 'フィード' }, { id: 'STORY', name: 'ストーリー' } ]} />,
        <BaseSelect id="post_month" name="投稿月" type="number" change_ev={this.changeScore.bind(this)} list={monthList} />,
        <BaseSelect id="sp_option" name="表示条件" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: 'favorite', name: 'お気に入りのアカウントのみ表示' } ]} />,
        <BaseSelect id="follower_zone" name="フォロワー数" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: '0', name: 'ナノ (0～5000)' }, { id: '1', name: 'ナノ (5,000～10,000)' }, { id: '2', name: 'マイクロ (10,000～30,000)' }, { id: '3', name: 'マイクロ (30,000～50,000)' }, { id: '4', name: 'マイクロ (50,000～100,000)' }, { id: '5', name: 'マクロ (100,000～200,000)' }, { id: '6', name: 'マクロ (200,000～500,000)' }, { id: '7', name: 'トップ (500,000～)' } ]} />,
        <Line />,
        <Accordion name="カテゴリー" menus={[
          <CheckBox id="category" name="カテゴリーを選択" list={Const.value.categoryMst} change_ev={this.changeScoreArray.bind(this)} />,
        ]} />,
        //<BaseInput id="engagement" name="エンゲージメント率" type="number" change_ev={this.changeScore.bind(this)} />,
      ];
    } else {
      columns = [
        <InstaID />,
        <Keyword />,
        <Label />,
        <Line />,
        <Accordion name="詳細検索" menus={[
          <Slider id="followers" name="フォロワー数" change_ev={this.changeScore.bind(this)} range={FOLLOWERS_RANGE} points={[0,10,20,30]} />,
          <BaseInput id="engagement" name="エンゲージメント率(%)" type="number" change_ev={this.changeScore.bind(this)} />,
          <BaseSelect id="gender" name="性別指定" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: '1', name: '男性' }, { id: '2', name: '女性' } ]} />,
          <Slider id="generation" name="年代指定" change_ev={this.changeScore.bind(this)} range={GENERATION_RANGE} points={[0,1,2,3,4]} fmt={'0代'} />,
          <BaseInput id="feed_count" name="フィード投稿数" type="number" change_ev={this.changeScore.bind(this)} />,
          <BaseInput id="reel_count" name="リール投稿数" type="number" change_ev={this.changeScore.bind(this)} />,
          <BaseSelect id="is_digital_clone" name="デジタルクローン" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: '1', name: '生成済み' }, { id: '0', name: '未生成' }]} />,
        ]} />,
        <Accordion name="実績検索" menus={[
          <BaseSelect id="assign_flg" name="アサイン実績" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: '1', name: '実績のある人を表示' }, { id: '0', name: '実績のない人を表示' } ]} />,
          <BaseInput id="good_assign" name="アサイン回数" type="number" change_ev={this.changeScore.bind(this)} />,
          <BaseSelect id="reach_per" name="投稿実績の平均リーチ率" change_ev={this.changeScore.bind(this)} list={[{ id: 'all', name: '全て表示' }, { id: '10', name: '10%以上' }, { id: '20', name: '20%以上' }, { id: '30', name: '30%以上' }, { id: '40', name: '40%以上' }, { id: '50', name: '50%以上' } ]} />,
        ]} />,
        <Accordion name="NG設定" menus={[
          <NgLabelHelpMessage />,
          <NgLabel base={this.props.base} />,
        ]} />,
        <Accordion name="カテゴリー" menus={[
          <CheckBox id="category" name="カテゴリーを選択" list={Const.value.categoryMst} change_ev={this.changeScoreArray.bind(this)} />,
        ]} />,
      ];
    }
    
    return (
      <div className="influencer-conditions">
        {/*<h3>検索</h3>*/}
        
        <form className="forms">
          { columns.map((html, key) => {
            if( this.props.refresh == true ) return null;
            return React.cloneElement(html, { key: key, set_ev: this.changeSetting.bind(this) });
          })}
          
          <button className="hide" onClick={this.enterButton.bind(this)}></button>
        </form>
      </div>
    );
  }
}
// -------------------------------------------------------

class NgLabelHelpMessage extends React.Component {
  render() {
    return (
      <div><h6 className="error">※NG設定はブラウザに保存されます</h6></div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerConditions;